import { ATOM_KEY } from "@/shared/client/keys";
import { type ReserveInfoResponse } from "@/shared/server";
import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

const newDataAtom = atom<ReserveInfoResponse | undefined>({
    default: undefined,
    key: ATOM_KEY.RE_NEW_DATA,
});

export const useNewDataValue = () => useRecoilValue(newDataAtom);
export const useSetNewDataState = () => useSetRecoilState(newDataAtom);
export const useNewDataState = () => useRecoilState(newDataAtom);

const reserveAtom = atom({
    default: true,
    key: ATOM_KEY.RESERVE_SUCCESS,
});

export const useSetReserveSuccessState = () => useSetRecoilState(reserveAtom);
export const useReserveSuccessValue = () => useRecoilValue(reserveAtom);
